<template>
	<div class="dataOriginBox">
		<div class="data_box">
			<div class="dataTitle">
				<span class="must">*</span>
				<span>导入方式</span>
			</div>
			<div class="dataFileList">
				<el-radio v-model="activeType" :label="1" @change="activeSample">全部导入</el-radio>
  				<el-radio v-model="activeType" :label="2" @change="activeSample">等距抽样</el-radio>
  				<el-radio v-model="activeType" :label="3" @change="activeSample">随机抽样</el-radio>
			</div>
		</div>

		<div class="data_flex_box" v-if="activeType==2">
			<div>
				<div class="dataTitle">
					<span class="must">*</span>
					<span>起点</span>
				</div>
				<div><el-input-number size="medium" v-model="startValue" controls-position="right" @change="handleChange" :min="0"></el-input-number></div>
			</div>
			<div style="margin-left: 20px;">
				<div class="dataTitle">
					<span class="must">*</span>
					<span>间距</span>
				</div>
				<div><el-input-number size="medium" v-model="gapValue" controls-position="right" @change="handleChange" :min="0"></el-input-number></div>
			</div>
		</div>
		
		<div class="data_flex_box" v-if="activeType==3">
			<div>
				<div class="dataTitle">
					<span class="must">*</span>
					<span>随机个数</span>
				</div>
				<div><el-input-number size="medium" v-model="randomValue" controls-position="right" @change="handleChange" :min="0"></el-input-number></div>
			</div>
			
		</div>
	</div>
</template>

<script>
export default {
	props: {
		filePath: {
			type: String
		},
		fileData: {
			type: String
		},
		keyType:{
			type: String
		},
		source:{
			type: String
		}
	},
	data() {
		return {
			id: '',
			activeType: 1,
			startValue:0,
			gapValue:0,
			randomValue:0,
		};
	},
	created() {
		this.id = this.$route.query.id;
		console.log(this.filePath, this.fileData);
	},
	methods: {
		handleChange(){
			
		},
		importData() {
			let data = {
				uplodFieldUrl: this.filePath,
				importType: this.activeType,
				mappingFieldMapList: JSON.parse(this.fileData),
				qid: this.id,
				startValue:this.startValue,
				gapValue:this.gapValue,
				randomValue:this.randomValue,
				separatorText:this.keyType,
				source:this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.sampleImport}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						console.log(res)
						// that.$message.success(res.message);
						that.$emit('upLoadOk2')
					} else {
						that.$emit('upLoadOk2')
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		activeSample() {
			console.log('this.activeType :>> ', this.activeType);
			// this.activeType = index;
			this.$emit('type');
		}
	}
};
</script>
{'':'','':''}
<style lang="scss" scoped>
.dataOriginBox {
	width: 72%;
	margin: 20px auto;
	.data_box {
		margin-bottom: 20px;
		.dataTitle {
			height: 20px;
			display: flex;
			margin-bottom: 20px;
			.must {
				// background-color: rgba(255, 4, 4, 1);
				color: rgba(255, 4, 4, 1);
				margin-right: 6px;
				font-size: 20px;
				text-align: center;
			}
		}
		.dataFileList {
			.shu {
				width: 2px;
				height: 50px;
				background-color: #ffffff;
			}
			.sample {
				cursor: pointer;
				.bigText {
					font-size: 18px;
					margin-bottom: 10px;
					color: #ffffff;
				}
				.botText {
					color: #ffffff;
				}
			}
			.sampleActive {
				cursor: pointer;
				.bigText {
					font-size: 24px;
					font-weight: 800;
					margin-bottom: 10px;
					color: #0086ff;
				}
				.botText {
					color: #0086ff;
				}
			}
			.allUplad {
			}
			.equilong {
			}
			.random {
			}
		}
	}
	.data_flex_box {
		display: flex;
		margin-bottom: 20px;
		.dataTitle {
			height: 20px;
			display: flex;
			margin-bottom: 20px;
			.must {
				// background-color: rgba(255, 4, 4, 1);
				color: rgba(255, 4, 4, 1);
				margin-right: 6px;
				font-size: 20px;
				text-align: center;
			}
		}
	}
}
</style>
